import { render, staticRenderFns } from "./EditScriptDialog.vue?vue&type=template&id=83768a74&scoped=true"
import script from "./EditScriptDialog.vue?vue&type=script&lang=js"
export * from "./EditScriptDialog.vue?vue&type=script&lang=js"
import style0 from "./EditScriptDialog.vue?vue&type=style&index=0&id=83768a74&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83768a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83768a74')) {
      api.createRecord('83768a74', component.options)
    } else {
      api.reload('83768a74', component.options)
    }
    module.hot.accept("./EditScriptDialog.vue?vue&type=template&id=83768a74&scoped=true", function () {
      api.rerender('83768a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/EditScriptDialog.vue"
export default component.exports